module.exports = __webpack_public_path__ + "img/Great-Britain.d40d7bf9.png";